// extracted by mini-css-extract-plugin
export default {"supplierPage":"style_supplierPage__kdtpW","aboutSecondSection":"style_aboutSecondSection__oMeNN","supplierFormSection":"style_supplierFormSection__kDwDZ"};